import { Injectable } from '@angular/core';

declare global {
  interface Window {
    ym?: (id: number, method: string, ...args: unknown[]) => void;
  }
}

export const FUNNEL_MARKETING_ID = 108151065;

@Injectable({ providedIn: 'root' })
export class YmService {
  init(): void {
    const searchParams = new URLSearchParams(window.location.search);

    if (searchParams.get('from') === 'mm_landing') {
      this.reachGoal('from_mm_landing', FUNNEL_MARKETING_ID);
    }
  }

  reachGoal(goal: string, id: number): void {
    if (typeof window.ym === 'function') {
      window.ym(id, 'reachGoal', goal);
    }
  }

  sendPhoneNumber(phoneNumber: string, id: number = FUNNEL_MARKETING_ID): void {
    if (!phoneNumber || typeof window.ym !== 'function') {
      return;
    }

    window.ym(id, 'firstPartyParams', { phone_number: phoneNumber });
  }
}
